// extracted by mini-css-extract-plugin
export var content = "DesktopContent-module--content--4609a";
export var item = "DesktopContent-module--item--c427f";